import React, { Component } from 'react'
import ReactMarkdown from 'react-markdown'
import privacyPath from './Terms.md'

class Privacy extends Component {
  constructor(props) {
    super(props)

    this.state = { privacy: null }
  }

  componentWillMount() {
    fetch(privacyPath).then((response) => response.text()).then((text) => {
      this.setState({ privacy: text })
    })
  }

  render() {
    return (
      <div className="legal">
        <ReactMarkdown source={this.state.privacy} />
      </div>
    )
  }
}

export default Privacy